import Http from "./http";

export const addProductAPI = (data) => {
  return Http.post("admin/product/addProduct", data);
};
